import { Component } from '@theme/component';

class WachstoriaPurchaseSafety extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.section = this.closest('.shopify-section');
    this.section?.addEventListener('change', this.onSelection, true);
    this.showScent(this.dataset.selectedScent);
  }

  updatedCallback() {
    super.updatedCallback();
    this.showScent(this.dataset.selectedScent);
  }

  disconnectedCallback() {
    this.section?.removeEventListener('change', this.onSelection, true);
    super.disconnectedCallback();
  }

  onSelection = (event) => {
    const target = event.target;
    if (!(target instanceof HTMLSelectElement || target instanceof HTMLInputElement)) return;
    if (target.name !== 'options[Duft]') return;
    const picker = target.closest('variant-picker');
    if (!picker || picker.dataset.productId !== this.dataset.productId) return;
    this.showScent(target.value);
  };

  showScent(name) {
    const panels = [...this.querySelectorAll('[data-scent]')];
    const match = panels.some(panel => panel.dataset.scent === name);
    panels.forEach(panel => { panel.hidden = match && panel.dataset.scent !== name; });
  }
}

if (!customElements.get('wachstoria-purchase-safety')) {
  customElements.define('wachstoria-purchase-safety', WachstoriaPurchaseSafety);
}

